var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"forgot-password-form-container"},[_c('div',{staticClass:"forgot-password-form d-flex justify-center align-center"},[_c('ForgotPasswordForm')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }